export default __webpack_public_path__ + "static/Poppins-Bold-404e299be26d78e6679447ea7cb2d41f.ttf";